import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => {
  return {
    copyButton: {
      marginLeft: theme.spacing(2),
    },
  };
});
